export const actionTypes = {
  UPDATE_USER: 'UPDATE_USER',
};

export const updateUser = (userInfo) => ({
  type: actionTypes.UPDATE_USER,
  userInfo,
});
